module.exports = __webpack_public_path__ + "img/bb.dc8d6f54.png";